export default __webpack_public_path__ + "static/media/project5.bb6582d2.jpg";